import { render } from "./TagView.vue?vue&type=template&id=764f2808"
import script from "./TagView.vue?vue&type=script&lang=js"
export * from "./TagView.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/DMA-Frontend/DMA-Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__